import './sign-global-styles';

window.useSignTheme = true;
